import { useModel } from "./useModel"
import { NavigateFunction, NavigateOptions } from "react-router-dom"


export const useNav = (path: string, nav: NavigateFunction, options?: NavigateOptions): void => {
    const model = useModel();
    model.Set("model.wasNavigated", true);
    if(options !== undefined) {
        nav(path, options);
        return;
    }
    nav(path);
    return;
}

export const useWasNavigated = (): boolean => {
    const model = useModel();
    return model.Get("model.wasNavigated") === true;
}

export const useNavToRoot = (nav: NavigateFunction): void => {
    nav("/");
    return;
}
